<nz-drawer
	[nzClosable]="false"
	[(nzVisible)]="filtersDrawer"
	nzPlacement="right"
	(nzOnClose)="filtersDrawer = false"
	[nzTitle]="'common_filters-title' | translate"
	nzWidth="300"
>
    <hpf-text-translated-filters [searchParams]="searchParams" [resetPage]="true"></hpf-text-translated-filters>
</nz-drawer>
<hpf-text-translated-list-top-bar
    [title]="'text-translated_common_name' | translate"
	(filterEvent)="filtersDrawer = true"
	[searchParams]="searchParams"
	(createEvent)="onCreate()"
    [createButton]="'common_create' | translate"
    [showQuickSearch]="true"
    [quickSearchTooltip]="'common_search-by' | translate: { list: 'name' }"
    [quickSearchPlaceholder]="'common_quick-search' | translate"
    [showAdvancedSearch]="true"
></hpf-text-translated-list-top-bar>
<div class="container-fluid px-5">
    <div class="row my-5">
        <div class="col-12">
            <hpf-text-translated-table
                [searchParams]="searchParams"
                [enableMultiSelect]="true"
                [showActions]="true"
                (select)="onSelect($event)"></hpf-text-translated-table>
        </div>
    </div>
</div>
